import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { payFn, type PayRequestBody } from '@/api/payment/pay-fn';

export const usePayMutation = (
  opts?: UseMutationOptions<
    NonNullable<unknown>,
    DefaultQueryError,
    { body: PayRequestBody; checkoutType: string; isAutoDebit?: boolean }
  >
) =>
  useMutation<
    NonNullable<unknown>,
    DefaultQueryError,
    { body: PayRequestBody; checkoutType: string; isAutoDebit: boolean }
  >({
    mutationFn: ({ body, checkoutType, isAutoDebit }) =>
      payFn(body, checkoutType, isAutoDebit),
    ...opts,
  });
